













import { dispatchGetStaffDashboardStatistics } from '@/store/staff/actions';
import { readStaffDashboardStatistics } from '@/store/staff/getters';
import StatsByCountriesTable from '@/components/Staff/Dashboard/StatsByCountriesTable.vue';
import StaffStatsTable from '@/components/Staff/Dashboard/StaffStatsTable.vue';
import WorkZoneTable from '@/components/Staff/Dashboard/WorkZoneTable.vue';
import TasksListTable from '@/components/UserTasks/TasksListTable.vue';
import MyStructureTable from '@/components/Team/MyStructureTable.vue';
// import WaitingUsersTable from '@/components/Team/WaitingUsersTable.vue';
import TicketsListTable from '@/components/Tickets/TicketsListTable.vue';
import { Vue, Component } from 'vue-property-decorator';
import MdIcon from '@/components/vui-luma/Ui/MdIcon.vue';

@Component({
  components: {
    StatsByCountriesTable,
    StaffStatsTable,
    TasksListTable,
    MyStructureTable,
    WorkZoneTable,
    // WaitingUsersTable,
    TicketsListTable,
    MdIcon,
  },
})
export default class StaffDashboard extends Vue {

  public async mounted() {
    dispatchGetStaffDashboardStatistics(
        this.$store,
        {view_user_id: this.$router.currentRoute.params.pk ? Number(this.$router.currentRoute.params.pk) : undefined},
    );
  }

  public handleChangeStatisticsPeriod(period) {
    dispatchGetStaffDashboardStatistics(
      this.$store,
      {
        period,
        view_user_id: this.$router.currentRoute.params.pk ? Number(this.$router.currentRoute.params.pk) : undefined,
      },
    );
  }

  get dashboardStatistics() {
    return readStaffDashboardStatistics(this.$store);
  }

  public convertTimeSpent(total) {
      const seconds = total > 0 ? Math.floor( (total) % 60 ) : '00';
      const minutes = total > 0 ? Math.floor( (total / 60) % 60 ) : '00';
      const hours = total > 0 ? Math.floor( (total / (60 * 60)) % 24 ) : '00';
      const days = total > 0 ? Math.floor( total / (60 * 60 * 24) ) : '00';
      return `${days}:${hours}:${minutes}:${seconds}`;
  }

  public async handleReturnToDashboard() {
    await this.$router.push('/dashboard');
    this.$router.push('/staff-dashboard');
  }

}
